import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/moodbuster-short-logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-5f8e7162"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "OTP-ending" }
const _hoisted_2 = {
  id: "otp-container",
  class: "row"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "moodbuster short logo"
  })
], -1))
const _hoisted_4 = { class: "info" }
const _hoisted_5 = { id: "title" }
const _hoisted_6 = { id: "description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, { menus: false }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("OTP.TITLE")), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("OTP.DESCRIPTION")), 1)
      ])
    ])
  ]))
}